import script from "./SchoolSetupWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSetupWizard.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSetupWizard.vue?vue&type=style&index=0&id=5386b35c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5386b35c"]])

export default __exports__